module.exports = __webpack_public_path__ + "img/icon_like.db23be0c.svg";